import {
    UpdateKEKEndorsementOffer,
    UpdateKEKEndorsementOfferVariables,
} from "_graphql/kek/mutation/__generated__/UpdateKEKEndorsementOffer";
import { useMutation, useReactiveVar } from "@apollo/client";
import { StepFormBuilder } from "../..";
import _ from "lodash";
import { createTreatyFormItems } from "./form-steps";
import { currentUserVar } from "_graphql/cache/auth";
import toast from "react-hot-toast";
import { updateKEKEndorsementOffer } from "_graphql/kek/mutation/index.kek";
import { useEffect } from "react";
import { useFormik } from "formik";
import { GetKEKEndorsement_singleEndorsement } from "_graphql/kek/queries/__generated__/GetKEKEndorsement";

type Props = {
    setClose?: (value: boolean) => void;
    endorsement?: GetKEKEndorsement_singleEndorsement | null;
};

const UpdateKEKEndorsementFormContainer = ({
    setClose,
    endorsement,
}: Props) => {
    const user = useReactiveVar(currentUserVar);
    const [initiateAddMeeting] = useMutation<
        UpdateKEKEndorsementOffer,
        UpdateKEKEndorsementOfferVariables
    >(updateKEKEndorsementOffer, {
        refetchQueries: ["GetKEKEndorsements"],
    });

    const form = useFormik<any>({
        initialValues: {
            offer: {
                offer: "",
            },
            details: {
                class_of_business_id: "",
                offer_details: [],
                insurer_id: "",
                premium: "",
                policy_number: "",
                insured_by: "",
                sum_insured: "",
                rate: "",
                facultative_offer: "",
                commission: "",
                brokerage: "",
                currency: "",
                period_of_insurance_from: "",
                period_of_insurance_to: "",
                co_insurance_share: "",
                comment: "",
                information_comment: "",
                business_state: "",
                payment_type: "",
                reinsurer_id: "",
                ex_currency: "",
                ex_rate: "",
            },
        },
        onSubmit: async (values) => {
            await initiateAddMeeting({
                variables: {
                    offerInput: {
                        offer_comment: values?.comment || "",
                        offer_details: JSON.stringify(
                            values.details.old_offer_detail
                        ),
                        ...(_.omit(values.details, [
                            "old_class_of_business_id",
                            "old_offer_detail",
                            "comment",
                            "offer_details",
                            "payment_type",
                            "no_of_installments",
                            "include_nkrol_comment",
                            "addExchangeRate",
                        ]) as any),
                        employee_id: user?.employee?.employee_id ?? "",
                        payment_type: {
                            [values.payment_type]:
                                values.payment_type === "payable_in_full"
                                    ? "Facultative Premium payable in full at inception"
                                    : values.no_of_installments,
                        },
                    },
                    offerId: values?.offer?.exisitingOffer?.offer_id,
                },
            }).then((res) => {
                if (res.data?.updateEndorsementOffer) {
                    toast.success("Endorsement Updated Successfully");
                    setClose?.(false);
                }
            });
        },
    });

    useEffect(() => {
        if (endorsement) {
            form.setFieldValue("details", {
                class_of_business_id:
                    endorsement?.classofbusiness?.class_of_business_id,
                offer_details: JSON.parse(
                    endorsement.offer_endorsement_detail?.offer_detail || "[]"
                ),
                old_offer_detail: JSON.parse(
                    endorsement.offer_endorsement_detail?.offer_detail || "[]"
                ),
                insurer_id: endorsement.insurer?.insurer_id,
                premium: endorsement.premium,
                policy_number:
                    endorsement?.offer_endorsement_detail?.policy_number,
                insured_by: endorsement?.offer_endorsement_detail?.insured_by,
                sum_insured: endorsement.sum_insured,
                rate: endorsement.rate,
                facultative_offer: endorsement.facultative_offer,
                commission: endorsement.commission,
                brokerage: endorsement.brokerage,
                currency: endorsement.offer_endorsement_detail?.currency,
                period_of_insurance_from:
                    endorsement.offer_endorsement_detail
                        ?.period_of_insurance_from,
                period_of_insurance_to:
                    endorsement.offer_endorsement_detail
                        ?.period_of_insurance_to,
                comment: endorsement?.offer_endorsement_detail?.offer_comment,
                co_insurance_share: endorsement.offer?.co_insurance_share || "",
                information_comment: endorsement?.offer_endorsement_detail?.information_comment,
                business_state: endorsement?.offer?.business_state || "",
                payment_type: endorsement?.offer?.offer_detail?.payment_type || "",
                reinsurer_id: endorsement?.offer?.offer_retrocedent?.reinsurer?.reinsurer_id || "",
                ex_currency: endorsement?.offer?.exchange_rate?.ex_currency || "",
                ex_rate: endorsement?.offer?.exchange_rate?.ex_rate || "",

            });

            form.setFieldValue("offer.offer", endorsement.offer?.offer_id);
            form.setFieldValue("offer.exisitingOffer", endorsement.offer);
        }
    }, [endorsement]);

    return (
        <StepFormBuilder
            initialStep={0}
            formSteps={createTreatyFormItems}
            form={form}
            setOpen={setClose}
        />
    );
};

export default UpdateKEKEndorsementFormContainer;
